import React from 'react'
import numbro from 'numbro'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { currencyCode } from 'supporticon/utils/currencies'
import { selectLocalisation } from '../../../store/site'
import { symbolFromCurrencyCode } from '../../../lib/currencySymbol'

import ContentSection from '../../ui/ContentSection'
import Heading from 'constructicon/heading'
import LinkHandler from '../../utils/LinkHandler'

const TeamMembers = ({
  alignment,
  background,
  classNames,
  copy,
  country,
  foreground,
  fundraisingPage,
  spacing,
  styles,
  title
}) => {
  return (
    <ContentSection
      alignment={alignment}
      background={background}
      copy={copy}
      foreground={foreground}
      spacing={spacing}
      title={title}
    >
      {fundraisingPage.members.length > 0 ? (
        <div className={classNames.root}>
          {fundraisingPage.members.map(member => {
            const renderAmount = amount => {
              const defaultCurrency = currencyCode(country)
              const currency = member.currencyCode || defaultCurrency

              return currency !== defaultCurrency
                ? `${currency} ${symbolFromCurrencyCode(currency)}${numbro(member.raised).format('0,0.[00]')}`
                : numbro(member.raised).formatCurrency('0,0.[00]')
            }

            return (
              <LinkHandler
                key={member.id}
                className={classNames.card}
                to={`/fundraising/${member.slug}`}
              >
                {member.image && (
                  <img
                    src={member.image}
                    alt={member.name}
                    className={classNames.image}
                  />
                )}
                <Heading size={0} spacing={0} tag='span' styles={styles.name}>
                  {member.name}
                </Heading>
                <Heading size={0} spacing={{ x: 0.333 }} tag='span' styles={styles.amount}>
                  {renderAmount()}
                </Heading>
              </LinkHandler>
            )
          })}
        </div>
      ) : (
        <p className={classNames.card}>This team currently has no members.</p>
      )}
    </ContentSection>
  )
}

const mapStateToProps = (state) => ({
  ...selectLocalisation(state)
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(TeamMembers)
